module.exports = __webpack_public_path__ + "img/cn_pocket-10.fa99f17.jpg";